export default __webpack_public_path__ + "static/media/property_857.22f6bc24.png";